import { render, staticRenderFns } from "./veStuHygieneStudentMy.vue?vue&type=template&id=5883e8e6&scoped=true"
import script from "./veStuHygieneStudentMy.vue?vue&type=script&lang=js"
export * from "./veStuHygieneStudentMy.vue?vue&type=script&lang=js"
import style0 from "./veStuHygieneStudentMy.vue?vue&type=style&index=0&id=5883e8e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5883e8e6",
  null
  
)

export default component.exports